import JoelStraleyStarWarsLogo from "../../photos/Intro/Joel_Straley-Transparent-Background.png";
import "../Intro/intro-styles.css";

export default function Intro() { 


    const handleClick = () => {
        return window.location.href = '/main'
    }

    return (
        <>
        <div class="intro-container">
            <div class="main-scroll">
                <button class="btn--enter" onClick={() => handleClick()}>CLICK TO ENTER</button>
                    <img 
                        class="logo"
                        src={JoelStraleyStarWarsLogo}
                        alt="Star Wars Logo"
                    />
                    <p class="scroll">
                        It is a period of civil war.
                        Rebel spaceships, striking
                        from a hidden base, have won
                        their first victory against
                        the evil Galactic Empire.
                        <br /><br />
                        During the battle, Rebel
                        spies managed to steal secret
                        plans to the Empire's
                        ultimate weapon, the DEATH
                        STAR, an armored space
                        station with enough power to
                        destroy an entire planet.
                        <br /><br />
                        Pursued by the Empire's
                        sinister agents, Princess
                        Leia races home aboard her
                        starship, custodian of the
                        stolen plans that can save
                        her people and restore
                        freedom to the galaxy....
                        <br />
                    </p>
            </div>
        </div>
        </>
    )

}